import { isPopulatedAccessSetting, type AccessSetting } from '../../hooks/useAccessSettings';

/**
 * The options of an event's access-settings select: the listed settings and, when the event carries its own inline
 * (the expand), that one too, so a page that may not list the table (the Front Desk) still shows the event's setting.
 */
export const accessSettingOptions = (
  listed: AccessSetting[] | undefined,
  inline: Partial<AccessSetting> | null | undefined,
): Array<{ id: number; label: string }> => {
  const options = (listed || []).filter(isPopulatedAccessSetting).map((s) => ({ id: s.id, label: s.name || `Unnamed (#${s.id})` }));
  if (inline && typeof inline.id === 'number' && !options.some((o) => o.id === inline.id)) {
    options.push({ id: inline.id, label: inline.name || `Unnamed (#${inline.id})` });
  }
  return options;
};
